/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Blacklist } from '../models/Blacklist';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BlacklistService {
    /**
     * Add a new Blacklist
     * @param workspaceId Workspace ID required
     * @param requestBody
     * @returns any Successfully added
     * @throws ApiError
     */
    public static postBlacklist(
        workspaceId: string,
        requestBody: {
            value: string;
            type: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/blacklist',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List of Blacklists
     * @param workspaceId Workspace ID required
     * @returns Blacklist Successfully retrieved list
     * @throws ApiError
     */
    public static getBlacklist(
        workspaceId: string,
    ): CancelablePromise<Blacklist> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/blacklist',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Deletes a Blacklist
     * @param id The id of channel to get or delete
     * @param type type can be partial_url, exact_url, email or ip_address
     * @param workspaceId Workspace ID is required in every request
     * @returns any Successfully deleted Blacklist
     * @throws ApiError
     */
    public static deleteBlacklist(
        id: string,
        type: string,
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/blacklist/{id}',
            path: {
                'id': id,
            },
            query: {
                'type': type,
                'workspace_id': workspaceId,
            },
            errors: {
                404: `Blacklist not found`,
                500: `Internal server error`,
            },
        });
    }
}
